<template>
  <div>
    <van-popup position="right" :close-on-click-overlay="false" round v-model="show"
               :style="{ width: '90%',backgroundColor:'#eae9e9'}">
      <van-nav-bar title="选择合同" left-text="取消" right-text="确定" @click-left="close" @click-right="popupSubmit"/>
      <van-search v-model="queryParams.contractName" show-action @search="onSearch" clearable shape="round"/>
      <div style="overflow-y: auto" class="h-vh-70">
        <div class="p-10">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list :immediate-check="false" v-model="loading" :error.sync="error" :finished="finished"
                      finished-text="没有更多了" @load="getList"
                      class="p-l-20 p-r-20 p-b-20">
              <div @click="change(item)" v-for="(item,index) in list" :key="index"
                   class="bg-FF p-20 m-t-20 b-r-10"
                   :style="{border: item.activated ? '3px solid #F8B91A' : ''}">
                <div class="flex col-center row-between">
                  <!--                  <img class="w-52 h-52" :src="`${image_base_url}/zhengxuanlist_icon.png`"></img>-->
                  <!-- 标题 -->
                  <div class="flex-1 font-30 cor-3E3A39 font-weight-600">
                    {{ item.contractName }}
                  </div>
                </div>

                <van-row type="flex" align="center" class="m-t-30">
                  <van-col span="10">
                    <div class="cor-88 font-30">合同金额(万元)</div>
                  </van-col>
                  <van-col span="14">
                    <div class="cor-33 font-30 van-multi-ellipsis--l3">
                      {{ reserveLength(Number(item.contractAmount)) }}
                    </div>
                  </van-col>
                </van-row>


                <van-row type="flex" align="center" class="m-t-10">
                  <van-col span="10">
                    <div class="cor-88 font-30">项目名称</div>
                  </van-col>
                  <van-col span="14">
                    <div class="cor-33 font-30 van-multi-ellipsis--l3">
                      {{ item.projectName }}
                    </div>
                  </van-col>
                </van-row>
                <van-row type="flex" align="center" class="m-t-10">
                  <van-col span="10">
                    <div class="cor-88 font-30">客户</div>
                  </van-col>
                  <van-col span="14">
                    <div class="cor-33 font-30 van-multi-ellipsis--l3">
                      {{ item.customerCompanyName }}
                    </div>
                  </van-col>
                </van-row>
                <van-row v-if="item.contractTime" type="flex" align="center" class="m-t-10">
                  <van-col span="10">
                    <div class="cor-88 font-30">签订日期</div>
                  </van-col>
                  <van-col span="14">
                    <div class="cor-33 font-30 van-multi-ellipsis--l3">
                      {{ moment(item.contractTime).format('YYYY-MM-DD') }}
                    </div>
                  </van-col>
                </van-row>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {contractList} from '@/api/flow'
import moment from "moment";
import {mapState} from "vuex";
import flow from "@/mixin/flow"

export default {
  mixins: [flow],
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      image_base_url: state => state.settings.image_base_url,
    })
  },
  data() {
    return {
      moment,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      selectdList: [],

      queryParams: {
        pageNum: 1,
        pageSize: 20,
        status: '4',
        type: '0',
        contractName: '',
        reasonable: false
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    close() {
      this.$emit('close')
      this.list.forEach(item => {
        delete item.activated
      })
    },
    change(item) {
      if (this.selectdList.length > 0) {
        if (item.contractId === this.selectdList[0].contractId) {
          return
        }
      }

      if (item.activated) {
        this.$set(item, 'activated', !item.activated)
      } else {
        this.$set(item, 'activated', true)
      }

      if (item.activated) {
        if (this.selectdList.length >= 1) {
          this.list.forEach(ele => {
            if (ele.contractId === this.selectdList[0].contractId) {
              this.$set(ele, 'activated', false)
            }
          })
          this.selectdList = []
        }
        this.selectdList.push(item)
      }

    },
    // 下拉
    onRefresh() {
      this.finished = false;
      this.list = []
      this.queryParams.pageNum = 1
      this.getList();
    },
    popupSubmit() {
      console.log('popupSubmit')
      console.log( this.selectdList)
      this.$emit('finish', this.selectdList)
      this.list.forEach(item => {
        delete item.activated
      })
      this.selectdList = []
    },
    onSearch(text) {
      this.queryParams.contractName = text;
      this.finished = false
      this.queryParams.pageNum = 1;
      this.list = []
      this.getList();
    },
    // 去重
    unique(arr) {
      return Array.from(new Set(arr))
    },
    getList() {
      this.loading = true;
      contractList(this.queryParams).then(res => {
        if (res.rows.length === 0) {
          this.finished = true
        }
        if (res.total === this.list.length) {
          this.finished = true
        }
        this.list = this.list.concat(res.rows)
        // this.list = this.unique(this.list.concat(res.rows))
        this.queryParams.pageNum++
        this.loading = false;
        this.refreshing = false;
      }).catch(err => {
        this.error = true
      })
    }

  }
}
</script>
<style lang="less">
.activated {
  border: 1px solid @theme-color;
}
</style>

